import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import WhySection from './components/WhySection';
import AppScreenshots from './components/AppScreenshots';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturesSection from './components/FeaturesSection';
import TelegramSection from './components/TelegramSection';
import SecuritySection from './components/SecuritySection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Plans from './pages/Plans';
import ConsensusAgentPage from './pages/ConsensusAgent';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';

const LandingPage = () => (
  <>
    <Header />
    <HeroSection />
    <WhySection />
    <AppScreenshots />
    <HowItWorksSection />
    <FeaturesSection />
    <TelegramSection />
    <SecuritySection />
    <FAQSection />
    <CTASection />
    <Footer />
    <CookieConsent />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/pricing" element={<Plans />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/consensusagent" element={<ConsensusAgentPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
